//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Badge, { BadgeType } from '@components/atoms/badge/Badge';

interface IProps {
  className?: string;
}

const StyledBadge = styled(Badge)(
  ({ theme }) => `
  &&& {
    background-color: ${theme.echo.components.badge.warning.background};
    color: ${theme.echo.components.badge.warning.text};
  }
`,
);

/**
 * Badge shown on content that has been flagged as AI-generated and is pending
 * moderation review (client-flagged content).
 */
export const InReviewBadge = ({ className }: IProps) => (
  <StyledBadge
    className={className}
    iconName='bullhorn'
    text='In review'
    type={BadgeType.Warning}
  />
);
